import { useQuery } from '@tanstack/react-query'
import type { PostalCodePublic } from '@sidegigllc/api/client'
import { fetchJson } from '../utils/fetchJson'
import type { GeoResponse } from '../types/geo'
import type { SelectedMarket } from '../providers/Market'

const ZIP_MAX_DISTANCE_TO_MARKET = 100

export function useDetectedMarket(): {
  data: SelectedMarket | null
  isLoading: boolean
} {
  const { data, isLoading } = useQuery<SelectedMarket | null>({
    queryKey: ['detectedMarket'],
    queryFn: async () => {
      const { postalCode } = await fetchJson<GeoResponse>('/api/geo')
      if (!postalCode) return null
      const res = await fetchJson<PostalCodePublic>(
        `/api/marketing/postal-code?postal_code=${encodeURIComponent(postalCode)}`,
      )
      const m = res.markets?.[0]
      if (!m || m.distance > ZIP_MAX_DISTANCE_TO_MARKET) return null
      return { marketId: m.id, marketName: m.name }
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  return { data: data ?? null, isLoading }
}
